<template>
  <div class="row full-width full-height"
    oncontextmenu="return false"
    @dragenter="listen__x__ondragenter"
    @dragleave="listen__x__ondragleave"
    @dragover="listen__x__ondragover"
    @drop="listen__x__ondrop"
    >
  
    <div class="full-height">
      <sample-image-list
        :images="sampleImages"
        :imageWidth="100"
        @jobstart="showLayer"
        @joberror="(param) => listen__x__onfileerror(param)"
        @jobdone="(file) => preprocessingFile(file)"
      />
    </div>
    <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
      
      <div style="flex:0 0 40px">
        <div class="row" style="padding-bottom: 6px;">
          <div class="row text-h6">
            {{title}}
            <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-if="isDev"/>
          </div>
          <q-space />
          <div class="row text-caption" style="align-items:center">
          </div>
        </div>
      </div>
      

    
      <div style="flex:0 0 15px;" />
    
      <div class="column bg-white shadow-1 full-width">
        <q-expansion-item icon="camera_alt" :label=cameraLabel class="bg-secondary full-width" default-opened dark expand-icon-class="text-secondary" :disable="checkPermission == false"
          @show="state.dialogCameraCapture.show = true"
          @hide="state.dialogCameraCapture.show = true">
        </q-expansion-item>
      </div>
    
      <div style="flex:0 0 15px;" />
    
    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile" :disable="checkPermission == false">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
          <q-separator vertical />
          <!-- <q-btn unelevated color="primary" :icon="state.withOcr ? 'check_box' : 'check_box_outline_blank'" label="OCR결과 표시" dense no-caps @click="state.withOcr = !state.withOcr" style="padding:0px 5px;" />
          <q-separator vertical /> -->
          <q-btn flat :ripple="false" dense no-caps style="padding:0px 5px;color:white;border:1px solid #027BE3">          
            <!-- <q-btn-group class="color-tool-btn-group" unelevated dense>
              <q-btn unelevated color="primary" :icon="state.colorByCell ? 'check_box_outline_blank' : 'check_box'" label="표" dense no-caps @click="listen__btn_color_cell__onclick" style="padding:0px 5px;font-size:11px;" />
              <q-separator vertical />
              <q-btn unelevated color="primary" :icon="state.colorByCell ? 'check_box' : 'check_box_outline_blank'" label="셀" dense no-caps @click="listen__btn_color_cell__onclick" style="padding:0px 5px;font-size:11px;" />
            </q-btn-group>
            <span style="color:black;font-size:12px;margin-left:5px;">단위로 표시</span> -->
            <q-btn unelevated color="primary" :icon="state.usePost ? 'check_box' : 'check_box_outline_blank'" label="후처리 사용" dense no-caps @click="state.usePost = !state.usePost" style="padding:0px 5px;" />
            <span style="color:black;font-size:12px;margin-left:20px;margin-right:10px;">투명도</span>
            <div style="width:100px;margin-right:8px;">
              <q-slider dense :value="state.opacity" @change="val => { state.opacity = val }" color="black" :min="0.0" :step="0.05" :max="1.0" label />
            </div>
          </q-btn>
          <q-separator vertical />
          <q-btn flat :ripple="false" dense no-caps style="padding:0px 5px;color:white;border:1px solid #027BE3">          
            <q-checkbox v-for="(type, i) in dlaTypeList"  keep-color :key="i" v-model="type.value" :color="`${type.name.toLowerCase()}-color`">
              <q-tooltip>
                {{ type.name }}
              </q-tooltip>
            </q-checkbox>
          </q-btn>
        </q-btn-group>
        <q-space />
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange" />
        </div>
      </div>
    </div>
  </div>
  
    <camera-capture-dialog v-if="state.dialogCameraCapture.show"
       :resolution="state.dialogCameraCapture.resolution"
      @oncapture="listen__dialogCameraCapture__oncapture"
      @onerror="state.dialogCameraCapture.show = false"
      />
  
    <q-dialog v-model="state.dialogOptions.show">
      <q-card style="width: 300px" class="q-px-sm q-pb-md">
        <q-card-section>
          <div class="text-h6">옵션</div>
        </q-card-section>
        <q-item-label header>문자영역 선 두께</q-item-label>
        <q-item class="row" dense>
          <div class="row" style="align-items:center;flex:0 0 50px;">
            <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
          </div>
          <div class="row col" style="align-items:center;justify-content:flex-end">
            <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
          </div>
        </q-item>
      </q-card>
    </q-dialog>
  
    <q-dialog v-model="state.dialogHelp">
      <q-card>
        <q-card-section>
          <div class="text-h6">{{title}}</div>
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          문서 구조 분석
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
          <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=177705423">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=177705423</a>
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
    Bob
        </q-card-section>
  
        <q-card-section class="q-pt-none">
          <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
    address
        </q-card-section>
  
        <q-card-actions align="right">
          <q-btn flat label="확인" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  
    <q-inner-loading :showing="state.loadingLayer.show">
      <q-spinner-facebook
          color="primary"
          size="2em"
        />
      {{ state.loadingLayer.message }}
    </q-inner-loading>
  
    <q-inner-loading :showing="compositionDropData.counterDrag > 0">
      <div class="text-h3">드롭하세요.</div>
    </q-inner-loading>
  
    <image-processing-dialog ref="image-processing-dialog"
      @done="listen__ip_dialog__done"
    />
  </div>
</template>
  
  
  <script>
  import compositionDrop from '@/composition/drop.js'
  import compositionFile from '@/composition/file.js'
  
  import MixinLayer from '@/mixins/layer.js'
  
  import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
  import SampleImageList from '@/components/SampleImageList2.vue'
  import ImageView from '@/projects/document/components/dla_view/ImageView.vue'
  import CameraCaptureDialog from '@/components/CameraCaptureDialog.vue'
  
  import PARSE from '@/js/parse.js'
  import MISC from '@/js/miscellaneous.js'
  import DocumentOCR from '@/js/document_ocr.js'
  import ETC from '@/js/etc.js'
  import UserJS from '@/js/user.js'
  
  import {getCurrentInstance} from '@vue/composition-api'
    
  export default {
    setup () {
      const vm = getCurrentInstance()
      if (null == vm ) {
        return {}
      }
      const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
      function preprocessingFile(data) {
        const file = data instanceof File ? data : data.file
        return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
      }
      const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
      return {
        compositionDropData,
        listen__x__ondragenter,
        listen__x__ondragleave,
        listen__x__ondragover,
        listen__x__ondrop,
        compositionDrop,
        compositionFileData,
        preprocessingFile
      }
    },
    mixins: [MixinLayer],
    data: function () {
      return {
        state: {
          dialogHelp: false,
          withOcr: false,
          opacity: 0.5,
          dialogOptions: {
            show: false
          },
          dialogCameraCapture: {
            show: false,
            resolution: 'vga'
          },
          fitToWindow: false,
          tab: 'text',
          currentFrameState: {
            coord: {
              x: 0,
              y: 0
            },
            zoom: undefined,
            voi: {
              windowCenter: 127,
              windowWidth: 256
            }
          },
          usePost: true,
          currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        },
        sampleImages: [
          {
            name: '문서 2',
            filename: 'DLA_0002.jpg',
            url:  `${process.env.VUE_APP_URL}/api/image/DLA_0002.jpg`
          },
          {
            name: '문서 3',
            filename: 'DLA_0003.jpg',
            url:  `${process.env.VUE_APP_URL}/api/image/DLA_0003.jpg`
          },
          {
            name: '문서 5',
            filename: 'DLA_0005.jpg',
            url:  `${process.env.VUE_APP_URL}/api/image/DLA_0005.jpg`
          },
          {
            name: '문서 7',
            filename: 'DLA_0007.jpg',
            url:  `${process.env.VUE_APP_URL}/api/image/DLA_0007.jpg`
          },
        ],
        colors: {
          Undetermined: MISC.convertRgbToHex(0, 0, 139), 
          Caption: MISC.convertRgbToHex(0, 201, 87), 
          Footnote: MISC.convertRgbToHex(191, 0, 255), 
          Formula: MISC.convertRgbToHex(255, 223, 0), 
          ListItem: MISC.convertRgbToHex(0, 206, 209), 
          PageFooter: MISC.convertRgbToHex(224, 17, 95), 
          PageHeader: MISC.convertRgbToHex(102, 255, 0), 
          Picture: MISC.convertRgbToHex(148, 0, 211), 
          SectionHeader: MISC.convertRgbToHex(0, 191, 255), 
          Table: MISC.convertRgbToHex(255, 207, 0), 
          Text: MISC.convertRgbToHex(65, 105, 225), 
          Title: MISC.convertRgbToHex(255, 0, 255),
          Line: MISC.convertRgbToHex(255, 0, 0)
        }, 
        frameData1: {
          _uid: MISC.getUuid4(),
          _empty: true
        },
        pred: [],
        retBlocks: [],
        jsonData: [],
        title: "문서구조분석",
        recognizeName: "dla",
        dlaTypeList: [
          { name: "Undetermined", color: MISC.convertRgbToHex(0, 0, 139), value: true }, 
          { name: "Caption", color: MISC.convertRgbToHex(0, 201, 87), value: true }, 
          { name: "Footnote", color: MISC.convertRgbToHex(191, 0, 255), value: true }, 
          { name: "Formula", color: MISC.convertRgbToHex(255, 223, 0), value: true }, 
          { name: "ListItem", color: MISC.convertRgbToHex(0, 206, 209), value: true }, 
          { name: "PageFooter", color: MISC.convertRgbToHex(224, 17, 95), value: true }, 
          { name: "PageHeader", color: MISC.convertRgbToHex(102, 255, 0), value: true }, 
          { name: "Picture", color: MISC.convertRgbToHex(148, 0, 211), value: true }, 
          { name: "SectionHeader", color: MISC.convertRgbToHex(0, 191, 255), value: true }, 
          { name: "Table", color: MISC.convertRgbToHex(255, 207, 0), value: true }, 
          { name: "Text", color: MISC.convertRgbToHex(65, 105, 225), value: true }, 
          { name: "Title", color: MISC.convertRgbToHex(255, 0, 255), value: true },
          { name: "Line", color: MISC.convertRgbToHex(255, 0, 0), value: true },
        ]
      }
    },
    components: {
      ImageProcessingDialog,
      SampleImageList,
      ImageView,
      CameraCaptureDialog
    },
    methods: {
      listen__x__onfilechange: function (file, options) {
        const Vue = this
        
        const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
        Vue.clearData(keepFrameData0)
        Vue.showLayer('이미지를 읽는 중...');
        
        MISC.doubleRaf(async () => {
          let image;
          
          let tokens = file.name.split('.');
          let ext = tokens[tokens.length - 1].toLowerCase();
          try {
            image = await PARSE.parseImage(file, ext);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
            return
          }
          let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);
  
          Vue.showLayer('인식 중...');
          let ret = {};
          let processingTime
          try {
            const begin = new Date();
            ret = await DocumentOCR.recognizeDocumentLayoutAnalysis(file, Vue.state.usePost);

            Vue.retBlocks.length = 0;
            if (ret.data != undefined) {
              if (ret.data.dla_block != undefined) {
                Vue.retBlocks = ret.data.dla_block
              }
            }

            processingTime = (new Date() - begin) / 1000
            
            ret.pred = Vue.makeDrawData(Vue, Vue.dlaTypeList);
          } catch (err) {
            console.log(err)
            Vue.listen__x__onfileerror({color: 'red', message: err})
            return
          }
          if (keepFrameData0 == true) {
            Vue.frameData1 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
          } else {
            Vue.frameData0 = {
              id: MISC.getUuid4(),
              name: file.name,
              cornerstoneImage,
              _empty: false
            }
            Vue.frameData1 = Vue.frameData0
          }
          Vue.pred = ret.pred
          ret.data['processingTime'] = processingTime
          Vue.jsonData = ret.data;
          Vue.hidingLayer()
        });
      },
      listen__x__onfileerror: function (param) {
        const Vue = this
  
        Vue.jsonData = []
        Vue.compositionFileData.files = []
        Vue.clearData()
        Vue.hidingLayer()
  
        let color = param.color
        if (color == undefined)
          color = 'black'
  
        Vue.$q.notify({
          message: param.message,
          icon: 'announcement',
          color
        })
      },
      listen__image_view__onstatechange: function (data) {
        if (data.coord != undefined)
          this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
        if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
    },
    listen__ip_dialog__done: async function (data) {
        const Vue = this
        if (Vue.frameData1.id != data.id) {
          Vue.listen__x__onfilechange(
            PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
            {keepFrameData0: true}
          )
        }
      },
      clearData: function (keepFrameData0) {
        if (keepFrameData0 == false) {
          this.frameData0 = {
            _uid: MISC.getUuid4(),
            _empty: true
          }
        }
        this.frameData1 = {
          _uid: MISC.getUuid4(),
          _empty: true
      }
      this.pred = []
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    getAddress: function () {
    },
    makeDrawData: function (Vue, dlaTypeList) {
      const blocks = Vue.retBlocks;
      let pred = []
      for (let nb in blocks) {
        let block = blocks[nb]
        const color_block = Vue.colors[block.category]
        let blockShow = dlaTypeList.find(type => type.name == block.category);
        if (blockShow && blockShow.value) {
          const shrink_dist = 5
          pred.push({
            id: nb, text: "",
            nindex: -1,
            category: block.category,
            confidence: block.confidence,
            active: true,
            highlight: false,
            color: color_block,
            opacity: MISC.toHex(parseInt(Vue.state.opacity * 255)),
            points: [
              {x: block['lt']['x'] + shrink_dist, y: block['lt']['y'] + shrink_dist},
              {x: block['rt']['x'] - shrink_dist, y: block['rt']['y'] + shrink_dist},
              {x: block['rb']['x'] - shrink_dist, y: block['rb']['y'] - shrink_dist},
              {x: block['lb']['x'] + shrink_dist, y: block['lb']['y'] - shrink_dist},
            ]
          });
        }
        let lineShow = dlaTypeList.find(type => type.name == "Line");
        if (lineShow && lineShow.value) {
          const color_block = Vue.colors["Line"];
          for (let nl in block.lines) {
            let line = block.lines[nl]
            
            const shrink_dist = 1
            pred.push({
              id: nb, text: "",
              nindex: nl,
              category: `${block.category} Line`,
              confidence: "1.0",
              active: true,
              highlight: false,
              color: color_block,
              opacity: MISC.toHex(parseInt(Vue.state.opacity * 255)),
              points: [
                {x: line['lt']['x'] + shrink_dist, y: line['lt']['y'] + shrink_dist},
                {x: line['rt']['x'] - shrink_dist, y: line['rt']['y'] + shrink_dist},
                {x: line['rb']['x'] - shrink_dist, y: line['rb']['y'] - shrink_dist},
                {x: line['lb']['x'] + shrink_dist, y: line['lb']['y'] - shrink_dist},
              ]
            });
          }
        }
      }
      return pred;
    }
  },
  computed: {
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '카메라 권한이 없습니다.' 
    }
  },
  watch: {
    "state.opacity": function (opacity) {
      for (let row of this.pred)
        row['opacity'] = MISC.toHex(parseInt(opacity * 255))
      this.$refs['image-view1'].updateTagging()
    },
    "dlaTypeList": {
      handler (newVal) {
        this.pred = this.makeDrawData(this, newVal);
      },
      deep: true
    }
  },
  async mounted () {
    if (this.isDev) {
      this.sampleImages.push({name: '문서 1', filename: 'DLA_0001.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0001.jpg`})
      this.sampleImages.push({name: '문서 4', filename: 'DLA_0004.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0004.jpg`})
      this.sampleImages.push({name: '문서 6', filename: 'DLA_0006.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0006.jpg`})      
      this.sampleImages.push({name: '문서 9', filename: 'DLA_0009.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0009.jpg`})
      this.sampleImages.push({name: '문서 10', filename: 'DLA_0010.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0010.jpg`})
      this.sampleImages.push({name: '문서 11', filename: 'DLA_0011.jpg', url: `${process.env.VUE_APP_URL}/api/image/DLA_0011.jpg`})
    }
    
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>

<style>
.color-tool-btn-group .q-btn__content > i {
  font-size: 15px;
  margin-right: 3px;
}
.color-tool-btn-group .q-btn__wrapper {
  padding:0 !important;
}
.text-undetermined-color {
  color: rgb(0, 0, 139) !important;
}
.text-caption-color {
  color: rgb(0, 201, 87) !important;
}
.text-footnote-color {
  color: rgb(191, 0, 255) !important;
}
.text-formula-color {
  color: rgb(255, 223, 0) !important;
}
.text-listitem-color {
  color: rgb(0, 206, 209) !important;
}
.text-pagefooter-color {
  color: rgb(224, 17, 95) !important;
}
.text-pageheader-color {
  color: rgb(102, 255, 0) !important;
}
.text-picture-color {
  color: rgb(148, 0, 211) !important;
}
.text-sectionheader-color {
  color: rgb(0, 191, 255) !important;
}
.text-table-color {
  color: rgb(255, 207, 0) !important;
}
.text-text-color {
  color: rgb(65, 105, 225) !important;
}
.text-title-color {
  color: rgb(255, 0, 255) !important;
}
.text-line-color {
  color: rgb(255, 0, 0) !important;
}
</style>
